import React from 'react'

const StudentClassSchedule = () => {
  return (
    <div>StudentClassSchedule</div>
  )
}

export default StudentClassSchedule